import { useMemo } from 'react';

import { useCacheQuery } from '../../../hooks/use-cache-query';
import {
  GetGlobalTranslationsDocument,
  GetGlobalTranslationsQueryVariables,
  GlobalTranslationItemDataFragment,
} from '../../types/api/graphql';

export function useGlobalTranslationItems(
  variables: GetGlobalTranslationsQueryVariables,
  skip?: boolean
) {
  const {
    data: globalTranslationItemsData,
    loading: globalTranslationItemsLoading,
  } = useCacheQuery(GetGlobalTranslationsDocument, {
    variables: {
      ...variables,
    },
    skip: skip === true,
  });

  const data = useMemo(
    () =>
      globalTranslationItemsData?.globalTranslations ??
      ([] as GlobalTranslationItemDataFragment[]),
    [globalTranslationItemsData?.globalTranslations]
  );

  return {
    data,
    loading: globalTranslationItemsLoading,
  };
}
